/**
 * Created by Jie Gao on 05/24/2019.
 */

import {
    ISymbolSizeConfig,
    ISymbolStateConfig
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GGReelSymbol} from "./GGReelSymbol";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

export class GGReelSymbolZ extends GGReelSymbol {

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    protected createSymAnimation():void {
        if(!this._symbolAnimations) {
            this._symbolAnimations = this.createSpineAnimation("DW_Landing");
            this.addChild(this._symbolAnimations);
            this._symbolAnimations.visible = false;
        }
    }

    public playLandingAnimation():void {
        this.createSymAnimation();
        this._symbolAnimations.visible = true;
        this._symbolAnimations.renderable = true;
        this._symbolAnimations.state.setAnimation(0, "Landing_03", false);

    }

    public playGlowAnimation():void {
        this.createSymAnimation();
        this._symbolAnimations.visible = true;
        this._symbolAnimations.renderable = true;
        this._symbolAnimations.state.setAnimation(0, "Landing_02", true);

    }

    public stopLandingAnimation():void {
        if(this._symbolAnimations) {
            this._symbolAnimations.visible = false;
        }
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            if(this._symbolAnimations) {
                this.addChild(this._symbolAnimations);
            }
            return true;
        }
        return false;
    }

    public updateBackground(symHeight:number):void {
        super.updateBackground(symHeight);
        for(let stateName in this._stateAnimations) {
            const state = this._stateAnimations[stateName];
            if(state != null) {
                state.scale.set(this._displayScale, this._displayScale);
            }
        }
    }

    public updateAnimations(symHeight:number):void {
        if(this._symbolAnimations) {
            this._symbolAnimations.scale.x = MathHelper.roundToDecimals(this._displayScale, 2);
            this._symbolAnimations.scale.y = MathHelper.roundToDecimals(this._displayScale, 2);
        }
    }
}